import api from './api';
import {
  AgentConnection,
  AgentConnectionCreate,
  DataConnection,
  DataConnectionCreate,
  DataConnectionUpdate,
  TestConnectionResult,
} from '../types/connection';

const API_BASE_URL = '';

// ---------------------------------------------------------------------------
// DataConnection CRUD
// ---------------------------------------------------------------------------

export async function getConnections(): Promise<DataConnection[]> {
  const response = await api.get(`${API_BASE_URL}/connections`);
  return response.data;
}

export async function getConnection(connectionId: string): Promise<DataConnection> {
  const response = await api.get(`${API_BASE_URL}/connections/${connectionId}`);
  return response.data;
}

export async function createConnection(payload: DataConnectionCreate): Promise<DataConnection> {
  const response = await api.post(`${API_BASE_URL}/connections`, payload);
  return response.data;
}

export async function updateConnection(
  connectionId: string,
  updates: DataConnectionUpdate,
): Promise<DataConnection> {
  const response = await api.put(`${API_BASE_URL}/connections/${connectionId}`, updates);
  return response.data;
}

export async function deleteConnection(connectionId: string): Promise<void> {
  await api.delete(`${API_BASE_URL}/connections/${connectionId}`);
}

export async function testConnection(connectionId: string): Promise<TestConnectionResult> {
  const response = await api.post(`${API_BASE_URL}/connections/${connectionId}/test`);
  return response.data;
}

// ---------------------------------------------------------------------------
// Agent <-> Connection attachment
// ---------------------------------------------------------------------------

export async function getAgentConnections(agentId: string): Promise<AgentConnection[]> {
  const response = await api.get(`${API_BASE_URL}/agents/${agentId}/connections`);
  return response.data;
}

export async function attachConnection(
  agentId: string,
  payload: AgentConnectionCreate,
): Promise<AgentConnection> {
  const response = await api.post(`${API_BASE_URL}/agents/${agentId}/connections`, payload);
  return response.data;
}

export async function detachConnection(
  agentId: string,
  agentConnectionId: string,
): Promise<void> {
  await api.delete(`${API_BASE_URL}/agents/${agentId}/connections/${agentConnectionId}`);
}
